import React, { useEffect, useRef, useState } from "react";
import {
  Avatar,
  Button,
  Col,
  Dropdown,
  Flex,
  Layout,
  Menu,
  Row,
  Space,
} from "antd";
import {
  UserOutlined,
  DashboardOutlined,
  MenuOutlined,
  CloseOutlined,
  LogoutOutlined,
  UserAddOutlined,
} from "@ant-design/icons";
import {
  useNavigate,
  useLocation,
  Outlet,
} from "react-router-dom";
import HeaderLogo from "../assets/images/WeekMate_Logo_White.svg";
import "../assets/scss/Admin.scss";
import "../assets/scss/style.scss"
import SuperadminLogo from "../assets/icons/SuperAdminIcon";
const { Header, Sider, Content } = Layout;

const AdminLayout = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

  const [mobileMenuVisible, setMobileMenuVisible] = useState(false);
  const [localdata, setlocaldata] = useState(
    JSON.parse(localStorage.getItem("user_data"))
  );
  
  const hasRunRef = useRef(false);

  const navigate = useNavigate();
  const location = useLocation();
  const [theme, setTheme] = useState("light");

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 767;
      setIsMobile(mobile);
      if (!mobile) {
        setMobileMenuVisible(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleMobileMenu = () => {
    setMobileMenuVisible(!mobileMenuVisible);
  };

  const handleMenuClick = ({ key }) => {
    navigate(key);
    if (isMobile) {
      setMobileMenuVisible(false);
    }
  };

  const menuItems = [
    {
      key: "/admin/dashboard",
      label: "Dashboard",
      icon: <DashboardOutlined />,
    },
    // {
    //   key: "/admin/manageUsers",
    //   label: "Manage",
    //   icon: <UserAddOutlined />,
    // },
  ];

  const items = [
    {
      key: "2",
      label: (
        <div className="logout-button" onClick={(e) => e?.stopPropagation()}>
          <Button
            onClick={() => {
              localStorage.clear();
              navigate("/");
            }}
            icon={<LogoutOutlined />}
          >
            Logout
          </Button>
        </div>
      ),
    }
  ];

  useEffect(() => {
    const savedTheme = "light";
    setTheme(savedTheme);
    document.documentElement.setAttribute("data-theme", savedTheme);
    const checkbox = document.getElementById("toggleBtn");
    if (checkbox) {
      if (savedTheme === "light") {
        checkbox.classList.add("light-mode");
        checkbox.classList.remove("dark-mode");
      } else {
        checkbox.classList.add("dark-mode");
        checkbox.classList.remove("light-mode");
      }
    }
  }, []);


  useEffect(() => {
    if (hasRunRef.current) return;
    hasRunRef.current = true;

    const path = window.location.pathname;
    const isAdminRoute = path.startsWith("/admin");
  
    if (isAdminRoute) {
      document.body.classList.add("admin-user");
      setTimeout(() => {
        document.body.classList.add("load-content");
      }, 250);
    } else {
      document.body.classList.remove("admin-user");
      setTimeout(() => {
        document.body.classList.remove("load-content");
      }, 0);
      if (document.body.classList.length === 0) {
        document.body.removeAttribute("class");
      }
    }
  }, [localdata]);

  return (
    <Layout className="app-wrapper admin" style={{ minHeight: "100dvh" }}>
      {/* Sidebar */}
      <Sider
        className="sidebar"
        width={120}
        style={{
          position: isMobile ? "fixed" : "relative",
          left: isMobile && !mobileMenuVisible ? "-180px" : "0",
          zIndex: isMobile ? 1000 : 1,
          height: isMobile ? "100vh" : "auto",
        }}
      >
        <div className="sidebar-header" style={{ position: "relative" }}>
          <div className="sidebar-logo">
            <SuperadminLogo
            />
          </div>

          {/* Mobile Close Button */}
          {isMobile && (
            <button
              className="sidebar-close-btn"
              onClick={() => setMobileMenuVisible(false)}
              onMouseEnter={(e) => e.target}
              onMouseLeave={(e) => e.target}
            >
              <CloseOutlined />
            </button>
          )}
        </div>

        <Menu
          className="sidebar-menu"
          selectedKeys={[location.pathname]}
          onClick={handleMenuClick}
        >
          {menuItems.map((item) => {
              return (
                <Menu.Item key={item.key} icon={item.icon}>
                  {item.label}
                </Menu.Item>
              );
            return null;
          })}
        </Menu>
      </Sider>

      {/* Mobile overlay */}
      {isMobile && mobileMenuVisible && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 999,
          }}
          onClick={() => setMobileMenuVisible(false)}
        />
      )}

      {/* Main layout */}
      <Layout style={{ marginLeft: isMobile ? 0 : undefined }}>
        {/* Header */}
        <Header className="header">
          <Row className="header-wrapper">
            {/* Mobile menu button */}
            {isMobile && (
              <Button
                type="text"
                className="mobile-menu-button"
                icon={<MenuOutlined />}
                onClick={toggleMobileMenu}
                style={{
                  fontSize: "14px",
                  width: 35,
                  height: 35,
                }}
              />
            )}

           
            <Col>
              <Dropdown
                menu={{ items }}
                placement="bottomRight"
                arrow={{ pointAtCenter: true }}
                trigger={["click"]}
                dropdownRender={(menu) => <div>{menu}</div>}
              >
                <Button
                  type="text"
                  className="user-button"
                  placement="bottomRight"
                >
                  <Space>
                    <span>{localdata?.first_name + " " + localdata?.last_name || "User"}</span>
                    <Avatar
                      className="user-avatar"
                      src={localdata?.profilePic}
                      icon={!localdata?.profilePic && <UserOutlined />}
                    />
                  </Space>
                </Button>
              </Dropdown>
            </Col>
          </Row>
        </Header>

        {/* Content Area */}
        <Content>
          <div
            className="content-wrapper"
            style={{
              Height: "100vh",
              maxHeight: "calc(100vh - 66px)",
              overflowY: "auto",
              padding: "10px",
            }}
          >
            <Outlet />
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default AdminLayout;
